import React, { Component, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

class OscInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            oscToVoices: {},
        };
    }

    componentDidMount() {
        let inst = this.props.instrument;
        this.timeout = setInterval(() => {
            let oscToVoices  = {... this.state.oscToVoices };
            for (let i in inst.oscillators) {
                let osc = inst.oscillators[i];
                let numVoices = osc.voices.filter(
                    x => x.oscillator.state === "started")
                    .length;
                oscToVoices[i] = numVoices;
            }
            this.setState({
                oscToVoices
            });
        }, 20);
    }

    componentWillUnount() {
        clearTimeout(this.timeout);
    }

    render() {
        let instrument = this.props.instrument;
        let oscillators = instrument.oscillatorNodes;
        return (
            <div className="oscs-info">
            {oscillators.map(
                (osc, voice) =>
                    <div className="osc">
                      {osc.name} - {this.state.oscToVoices[voice]}
                   </div>)}
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OscInfo);
